/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfOperationalContactLinkDto } from "../models/AjaxResponseOfListOfOperationalContactLinkDto";
import type { AjaxResponseOfOperationalContactLinkDto } from "../models/AjaxResponseOfOperationalContactLinkDto";
import type { CreateOrUpdateOperationalContactLinkInput } from "../models/CreateOrUpdateOperationalContactLinkInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class OperationalContactLinksAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfListOfOperationalContactLinkDto Success
   * @throws ApiError
   */
  public getAll({
    contactId,
  }: {
    contactId: number;
  }): CancelablePromise<AjaxResponseOfListOfOperationalContactLinkDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/contacts/{contactId}/links",
      path: {
        contactId: contactId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalContactLinkDto Success
   * @throws ApiError
   */
  public create({
    contactId,
    requestBody,
  }: {
    contactId: number;
    requestBody?: CreateOrUpdateOperationalContactLinkInput;
  }): CancelablePromise<AjaxResponseOfOperationalContactLinkDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/operational/contacts/{contactId}/links",
      path: {
        contactId: contactId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({
    contactId,
    linkId,
  }: {
    contactId: number;
    linkId: number;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/operational/contacts/{contactId}/links/{linkId}",
      path: {
        contactId: contactId,
        linkId: linkId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalContactLinkDto Success
   * @throws ApiError
   */
  public update({
    contactId,
    linkId,
    requestBody,
  }: {
    contactId: number;
    linkId: number;
    requestBody?: CreateOrUpdateOperationalContactLinkInput;
  }): CancelablePromise<AjaxResponseOfOperationalContactLinkDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/operational/contacts/{contactId}/links/{linkId}",
      path: {
        contactId: contactId,
        linkId: linkId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
}
